import React from 'react';
import { Helmet } from 'react-helmet';

function SEO({ title, description }) {
  const siteTitle = 'Cyber Wise Corp';
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} - Smart Cybersecurity for Everyone`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || 'Expert-reviewed cybersecurity assessments by supervised college interns. Know where you stand. Home assessments starting at $249.99.'} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || 'Expert-reviewed cybersecurity assessments by supervised college interns.'} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://cyberwisecorp.com" />
      <meta property="og:image" content="https://cyberwisecorp.com/images/cwc-logo-full.png" />
      <meta property="og:image:width" content="512" />
      <meta property="og:image:height" content="512" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:image" content="https://cyberwisecorp.com/images/cwc-logo-full.png" />
    </Helmet>
  );
}

export default SEO;
